import { SkeletonLoader } from "@saviynt/design-system";

interface ListSkeletonLoaderProps {
  count?: number;
}

export function ListSkeletonLoader({ count = 10 }: ListSkeletonLoaderProps) {
  return (
    <div className="flex flex-col gap-4 p-4">
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonLoader
          key={index}
          shape="square"
          animationStyle="wave"
          height="4.5rem"
          width="100%"
        />
      ))}
    </div>
  );
}
